import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'forms/rrf';
import ConfirmPopup from '../../../common/confirm-popup';
import RequiredInput from '../../../common/form/elements/required-input';

const model = 'deep.admin_pip_epos_submissions_form_decline_dialog';

class PipEposSubmissionsFormDeclineDialog extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.change(model, ''));
    dispatch(actions.reset(model));
  }

  render() {
    const { formValid, onHandleDecline, isValidated } = this.props;

    return (
      <ConfirmPopup
        confirmLabel="Decline"
        header="DECLINE PIP EPOS SUBMISSION"
        confirmDisabled={!formValid}
        onClose={onHandleDecline}
      >
        <div className="ta-left">
          {isValidated && (
            <p className="mg-top-20">
              This submission is already VALIDATED. Declining it will cause points removal.
            </p>
          )}
          <p>
            Please enter a reason for decline.
          </p>
          <Form model={model}>
            <RequiredInput
              controlId='decline_reason'
              model='.decline_reason'
            />
          </Form>
        </div>
      </ConfirmPopup>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_pip_epos_submissions_form_decline_dialog.$form.valid,
});

export default connect(mapStateToProps)(PipEposSubmissionsFormDeclineDialog);
